export default __webpack_public_path__ + "static/media/camp-s.432ac0eb.png";